import styled from "styled-components"
import { colors } from "../../helpers/colors"
import { fonts } from "../../helpers/fonts"
import { ContentWrapper as GlobalContentWrapper } from "../../ui/content-wrapper/content-wrapper-elements"
import {
  SectionWrapperStyles,
  ContentWrapperStyles,
  DescriptionStyles,
  ToggleBoxWrapperStyles,
  ItemsStyles,
  ItemWrapperStyles,
  ItemHeadingStyles,
  ItemHeadingIconStyles,
  ItemContentStyles,
  ItemDescriptionStyles,
} from "./toggle-box-styles"

interface IItemContent {
  opened: boolean
  height: number | undefined
}

export const SectionWrapper = styled.section`
  margin: 50px 0;
  ${SectionWrapperStyles}
`

export const ContentWrapper = styled(GlobalContentWrapper)`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1331px;
  ${ContentWrapperStyles}
`

export const Description = styled.p`
  max-width: 786px;
  text-align: center;
  ${DescriptionStyles}
`

export const ToggleBoxWrapper = styled.div`
  display: flex;
  width: 100%;
  border: 1px solid ${colors.gray};
  & > * {
    align-self: flex-start;
  }
  ${ToggleBoxWrapperStyles}
`

export const Items = styled.div`
  padding: 50px 80px;
  ${ItemsStyles}
`

export const ItemWrapper = styled.div`
  &:not(:last-child) {
    border-bottom: 1px solid ${colors.gray};
  }
  ${ItemWrapperStyles}
`

export const ItemHeading = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  padding: 10px 0;
  ${ItemHeadingStyles}
`

export const ItemHeadingIcon = styled.div`
  display: flex;
  align-items: center;
  font-size: ${fonts.sizes[4]};
  ${ItemHeadingIconStyles};
`

export const ItemContent = styled.div<IItemContent>`
  max-height: ${props => (props.opened ? props.height || 200 : 0)}px;
  transition: max-height 0.3s;
  overflow: hidden;
  ${ItemContentStyles}
`

export const ItemDescription = styled.div`
  margin-bottom: 20px;
  ${ItemDescriptionStyles}
`
